import { RepositoryFactory } from "repositories/factory";
import { MonitoringDevice, MONITORING_DEVICE_STATUS } from "models/monitoring-device";
import {
  MonitoringDevicesStoreValidator,
  MonitoringDevicesUpdateValidator,
  // MonitoringTargetsImageUploadValidator,
} from "validators/monitoring-devices";

const MabeeemlMonitoringDevicesRepository = RepositoryFactory.get("mabeeeml-monitoring-devices");

/* フォームアイテム */
class MabeeemlMonitoringDevicesController {
  constructor() {
    this._monitoringDevice = new MonitoringDevice();
  }

  get monitoringDevice() {
    return this._monitoringDevice;
  }

  set monitoringDevice(value) {
    this._monitoringDevice = value;
  }

  /* 算出プロパティ */
  isStore() {
    return !!this.monitoringDevice.productKey;
  }

  getMonitoringDeviceId() {
    return this.monitoringDevice.monitoringDeviceId;
  }

  isTerminated() {
    return this.monitoringDevice.monitoringDeviceStatus === MONITORING_DEVICE_STATUS.TERMINATED;
  }

  getTerminateAtText() {
    let res = "";
    if (this.monitoringDevice) {
      res = this.monitoringDevice.getTerminateAtText();
    }
    return res;
  }

  /* イベントハンドラ */
  /* 初期化・登録処理 */
  static async createInstance(organizationId, projectId, monitoringDeviceId = null) {
    // 初期化(DBの値をフォーム反映)
    const monitoringDevicesController = new MabeeemlMonitoringDevicesController();
    let monitoringDevice = new MonitoringDevice();

    // データが存在しない場合
    if (!monitoringDeviceId) {
      monitoringDevice = new MonitoringDevice(projectId);
      monitoringDevice.organizationId = organizationId;
    } else {
      monitoringDevice = await MabeeemlMonitoringDevicesRepository.get(
        projectId,
        monitoringDeviceId,
      );
    }
    monitoringDevicesController.monitoringDevice = monitoringDevice;
    return monitoringDevicesController;
  }

  async upsertValidate() {
    if (!this.monitoringDevice.isRegisterd()) {
      // 登録
      const result = await MonitoringDevicesStoreValidator.validate(
        this.monitoringDevice,
      );
      return result;
    }
    // 更新
    const result = await MonitoringDevicesUpdateValidator.validate(
      this.monitoringDevice,
    );
    return result;
  }

  // 登録/更新
  async upsert() {
    const updateItem = await MabeeemlMonitoringDevicesRepository.upsert(
      this.monitoringDevice,
    );
    this.monitoringDevice = updateItem;
  }

  async destroy() {
    await MabeeemlMonitoringDevicesRepository.destroy(
      this.monitoringDevice.projectId,
      this.monitoringDevice.monitoringDeviceId,
    );
    this.monitoringDevice = null;
  }
}

export {
  MabeeemlMonitoringDevicesController,
};
